import { render, staticRenderFns } from "./MembershipType.vue?vue&type=template&id=08a55451"
import script from "./MembershipType.vue?vue&type=script&lang=js"
export * from "./MembershipType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports